import styled from '@emotion/styled';

export const FilterLabel = styled.label`
  font-size: 1.8rem;
`;

export const QWERTY = styled.input``;

export const Input = styled.input`
  font-size: 1.8rem;
  width: 25rem;
  margin-bottom: 2rem;
  margin-left: 1rem;
  padding: 0.1rem 0.5rem;
  border-radius: 0.5rem;
`;
